import { get as getProjection } from 'ol/proj';
import { getWidth } from 'ol/extent';

/*
 * 橫麥卡托(Spherical Mercator)投影設定
 * http://openlayers.org/en/latest/examples/wmts.html
 */
export default function SphericalMercator(epsgStr) {
    const epsg = epsgStr || 'EPSG:3857';
    const projection = getProjection(epsg);
    const projectionExtent = projection.getExtent();
    const size = getWidth(projectionExtent) / 256;
    const resolutions = new Array(20);
    const matrixIds = new Array(20);

    for (let z = 0; z < 20; z += 1) {
        resolutions[z] = size / 2 ** z;
        matrixIds[z] = z;
    }
    return {
        epsg,
        projection,
        projectionExtent,
        size,
        resolutions,
        matrixIds,
    };
}
